<template>
    <div class="py-4 text-gray-500 dark:text-gray-400">
        <inertia-link
            class="text-lg font-bold text-gray-800 dark:text-gray-200"
            :href="$page.props.tenant ? route('tenant.dashboard', { tenant: $page.props.tenant.id }) : route('dashboard')"
        >
            <div class="px-6">
                <!--                <application-logo/>-->
                {{ $page.props.tenant ? $page.props.tenant.name : $page.props.app.name }}
            </div>
        </inertia-link>
        <ul class="mt-6">
            <sidebar-item :href="route('dashboard')" :active="route().current('dashboard')">
                <template v-slot:icon>
                    <svg class="w-5 h-5" aria-hidden="true" fill="none" stroke-linecap="round" stroke-linejoin="round"
                         stroke-width="2" viewBox="0 0 24 24" stroke="currentColor">
                        <path
                            d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6"
                        ></path>
                    </svg>
                </template>
                <template v-slot:title>Dashboard</template>
            </sidebar-item>
            <sidebar-item v-if="can('manage clients')" :href="route('admin.client.index')" :active="route().current('admin.client.index')">
                <template v-slot:icon>
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10 6H5a2 2 0 00-2 2v9a2 2 0 002 2h14a2 2 0 002-2V8a2 2 0 00-2-2h-5m-4 0V5a2 2 0 114 0v1m-4 0a2 2 0 104 0m-5 8a2 2 0 100-4 2 2 0 000 4zm0 0c1.306 0 2.417.835 2.83 2M9 14a3.001 3.001 0 00-2.83 2M15 11h3m-3 4h2" />
                    </svg>
                </template>
                <template v-slot:title>Clients</template>
            </sidebar-item>
            <sidebar-item v-if="can('manage users', $page.props.tenant?.id)" :href="route('admin.user.index')" :active="route().current('admin.user.index')">
                <template v-slot:icon>
                    <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"
                         xmlns="http://www.w3.org/2000/svg">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                              d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"></path>
                    </svg>
                </template>
                <template v-slot:title>Users</template>
            </sidebar-item>
            <sidebar-item v-if="can('manage projects')" :href="route('admin.project.index', {client: 0})" :active="route().current('admin.project.index')">
                <template v-slot:icon>
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 19a2 2 0 01-2-2V7a2 2 0 012-2h4l2 2h4a2 2 0 012 2v1M5 19h14a2 2 0 002-2v-5a2 2 0 00-2-2H9a2 2 0 00-2 2v5a2 2 0 01-2 2z" />
                    </svg>
                </template>
                <template v-slot:title>Projects</template>
            </sidebar-item>
            <sidebar-item v-if="can('manage tickets')" :href="route('admin.ticket.index')" :active="route().current('admin.ticket.index')">
                <template v-slot:icon>
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M7,16 L17,16 L17,8 L7,8 L7,16 Z M20,12 C20,14 21,15 23,15 L23,20 L1,20 L1,15 C3,15 4,14 4,12 C4,10 3,9 1,9 L1,4 L23,4 L23,9 C21,9 20,10 20,12 Z"/>
                    </svg>
                </template>
                <template v-slot:title>Ticketing</template>
            </sidebar-item>
            <sidebar-submenu :active="isQuoteManagementRouteActive">
                <template v-slot:icon>
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-3 7h3m-3 4h3m-6-4h.01M9 16h.01" />
                    </svg>
                </template>
                <template v-slot:title>Quote management</template>
                <template v-slot:submenuItems>
                    <sidebar-submenu-item v-if="can('manage quotes')" :href="route('admin.quote.index', {client: 0})" :active="isQuoteRouteActive">
                        <template v-slot:icon>
                            <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                                <path stroke-linecap="round" stroke-linejoin="round" d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-3 7h3m-3 4h3m-6-4h.01M9 16h.01" />
                            </svg>
                        </template>
                        <template v-slot:title>Quotes</template>
                    </sidebar-submenu-item>
                    <sidebar-submenu-item v-if="can('manage quotes')" :href="route('admin.quote-template.index')" :active="isQuoteTemplateRouteActive">
                        <template v-slot:icon>
                            <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                                <path stroke-linecap="round" stroke-linejoin="round" d="M4 5a1 1 0 011-1h14a1 1 0 011 1v2a1 1 0 01-1 1H5a1 1 0 01-1-1V5zM4 13a1 1 0 011-1h6a1 1 0 011 1v6a1 1 0 01-1 1H5a1 1 0 01-1-1v-6zM16 13a1 1 0 011-1h2a1 1 0 011 1v6a1 1 0 01-1 1h-2a1 1 0 01-1-1v-6z" />
                            </svg>
                        </template>
                        <template v-slot:title>Quote Templates</template>
                    </sidebar-submenu-item>
                    <sidebar-submenu-item v-if="$page.props.auth.isSuperAdmin" :href="route('admin.quote-theme.index')" :active="isQuoteThemeRouteActive">
                        <template v-slot:icon>
                            <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                                <path stroke-linecap="round" stroke-linejoin="round" d="M5 3v4M3 5h4M6 17v4m-2-2h4m5-16l2.286 6.857L21 12l-5.714 2.143L13 21l-2.286-6.857L5 12l5.714-2.143L13 3z" />
                            </svg>
                        </template>
                        <template v-slot:title>Quote Themes</template>
                    </sidebar-submenu-item>
                    <sidebar-submenu-item v-if="$page.props.auth.isSuperAdmin" :href="route('admin.quote-block-type.index')" :active="isQuoteBlockTypeRouteActive">
                        <template v-slot:icon>
                            <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                                <path stroke-linecap="round" stroke-linejoin="round" d="M11 4a2 2 0 114 0v1a1 1 0 001 1h3a1 1 0 011 1v3a1 1 0 01-1 1h-1a2 2 0 100 4h1a1 1 0 011 1v3a1 1 0 01-1 1h-3a1 1 0 01-1-1v-1a2 2 0 10-4 0v1a1 1 0 01-1 1H7a1 1 0 01-1-1v-3a1 1 0 00-1-1H4a2 2 0 110-4h1a1 1 0 001-1V7a1 1 0 011-1h3a1 1 0 001-1V4z" />
                            </svg>
                        </template>
                        <template v-slot:title>Quote Block Types</template>
                    </sidebar-submenu-item>
                    <sidebar-submenu-item v-if="$page.props.auth.isSuperAdmin" :href="route('admin.quote-block.index')" :active="isQuoteBlockRouteActive">
                        <template v-slot:icon>
                            <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                                <path stroke-linecap="round" stroke-linejoin="round" d="M11 4a2 2 0 114 0v1a1 1 0 001 1h3a1 1 0 011 1v3a1 1 0 01-1 1h-1a2 2 0 100 4h1a1 1 0 011 1v3a1 1 0 01-1 1h-3a1 1 0 01-1-1v-1a2 2 0 10-4 0v1a1 1 0 01-1 1H7a1 1 0 01-1-1v-3a1 1 0 00-1-1H4a2 2 0 110-4h1a1 1 0 001-1V7a1 1 0 011-1h3a1 1 0 001-1V4z" />
                            </svg>
                        </template>
                        <template v-slot:title>Quote Blocks</template>
                    </sidebar-submenu-item>
                </template>
            </sidebar-submenu>
            <sidebar-item v-if="can('manage added extras')" :href="route('admin.added-extra.index')" :active="route().current('admin.added-extra.index')">
                <template v-slot:icon>
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M9 12l2 2 4-4M7.835 4.697a3.42 3.42 0 001.946-.806 3.42 3.42 0 014.438 0 3.42 3.42 0 001.946.806 3.42 3.42 0 013.138 3.138 3.42 3.42 0 00.806 1.946 3.42 3.42 0 010 4.438 3.42 3.42 0 00-.806 1.946 3.42 3.42 0 01-3.138 3.138 3.42 3.42 0 00-1.946.806 3.42 3.42 0 01-4.438 0 3.42 3.42 0 00-1.946-.806 3.42 3.42 0 01-3.138-3.138 3.42 3.42 0 00-.806-1.946 3.42 3.42 0 010-4.438 3.42 3.42 0 00.806-1.946 3.42 3.42 0 013.138-3.138z" />
                    </svg>
                </template>
                <template v-slot:title>Added extras</template>
            </sidebar-item>
            <sidebar-item v-if="can('manage posts')" :href="route('admin.post.index')" :active="route().current('admin.post.index')">
                <template v-slot:icon>
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M19 20H5a2 2 0 01-2-2V6a2 2 0 012-2h10a2 2 0 012 2v1m2 13a2 2 0 01-2-2V7m2 13a2 2 0 002-2V9a2 2 0 00-2-2h-2m-4-3H9M7 16h6M7 8h6v4H7V8z" />
                    </svg>
                </template>
                <template v-slot:title>Posts</template>
            </sidebar-item>
        </ul>
        <!--        <div class="px-6 my-6">-->
        <!--            <button-->
        <!--                class="flex items-center justify-between w-full px-4 py-2 text-sm font-medium leading-5 text-white transition-colors duration-150 bg-red-600 border border-transparent rounded-lg active:bg-red-600 hover:bg-red-700 focus:outline-none focus:shadow-outline-red"-->
        <!--            >-->
        <!--                Create account-->
        <!--                <span class="ml-2" aria-hidden="true">+</span>-->
        <!--            </button>-->
        <!--        </div>-->
    </div>
</template>

<script>
import SidebarSubmenu from "@/Jetstream/SidebarSubmenu";
import SidebarSubmenuItem from "@/Jetstream/SidebarSubmenuItem";
import SidebarItem from "@/Jetstream/SidebarItem";
import ApplicationLogo from "@/Jetstream/ApplicationLogo";

export default {
    name: "Sidebar",
    components: {
        ApplicationLogo,
        SidebarItem,
        SidebarSubmenu,
        SidebarSubmenuItem,
    },
    setup() {
        const isQuoteRouteActive = route().current('admin.quote.index')
            || route().current('admin.quote.create')
            || route().current('admin.quote.edit');

        const isQuoteTemplateRouteActive = route().current('admin.quote-template.index')
            || route().current('admin.quote-template.create')
            || route().current('admin.quote-template.edit');

        const isQuoteThemeRouteActive = route().current('admin.quote-theme.index')
            || route().current('admin.quote-theme.create')
            || route().current('admin.quote-theme.edit');

        const isQuoteBlockTypeRouteActive = route().current('admin.quote-block-type.index')
            || route().current('admin.quote-block-type.create')
            || route().current('admin.quote-block-type.edit');

        const isQuoteBlockRouteActive = route().current('admin.quote-block.index')
            || route().current('admin.quote-block.create')
            || route().current('admin.quote-block.edit');

        const isQuoteManagementRouteActive = isQuoteRouteActive
            || isQuoteTemplateRouteActive
            || isQuoteThemeRouteActive
            || isQuoteBlockTypeRouteActive
            || isQuoteBlockRouteActive;

        return {
            isQuoteManagementRouteActive,
            isQuoteRouteActive,
            isQuoteTemplateRouteActive,
            isQuoteThemeRouteActive,
            isQuoteBlockTypeRouteActive,
            isQuoteBlockRouteActive
        }
    },
}
</script>

<style scoped>

</style>
